import { ContentBlockModel } from 'fourwaves-shared';
import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component
export default class ContentBlockMixin<T extends ContentBlockModel = ContentBlockModel> extends Vue {
  @Prop({ type: Object, required: true }) readonly block!: T;

  get newData(): T['newData'] {
    return this.block.newData;
  }

  get settings(): T['settings'] {
    return this.block.settings;
  }
}
